import React, { useState } from 'react';
import { Grid, Typography, FormControl, TextField, Button, Box, FormHelperText,InputBase,Paper } from '@mui/material';
import { Phone, Email } from '@mui/icons-material';
import { FileUploader } from 'react-drag-drop-files';
import Secure from "../../Assets/Images/secure.svg";
import TradeBossLogo from "../../ui-utils/latestPics/Footer.svg";
import call from "../../ui-utils/latestPics/call.svg"
import msg from "../../ui-utils/latestPics/msg.svg"
import { backendHosts,apiUrl } from "../../ui-utils/apiConfig";
import axios from "axios";
import en from "../../i18n/English/Support/home.json";
import hi from "../../i18n/Hindi/Support/home.json";
import kn from "../../i18n/Kannada/Support/home.json";
import ma from "../../i18n/Marathi/Support/home.json";
import gu from "../../i18n/Gujarati/Support/home.json";
import { useLanguage } from "../../Context/LangContext";
import './SupportMobileView.css'
import { fontFamily } from '@mui/system';
import DocumentMeta from 'react-document-meta'

const meta = {
  title: 'Support | 24/7 Help for Trading & Demat Accounts | TradeBoss',
  description: "Need help? Contact TradeBoss Support for expert guidance on trading, demat accounts, and investments. Fast, reliable, and always available.",
  canonical: 'https://tradeboss.co/support/contact',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'TradeBoss support, trading support India, demat account help, customer service trading platform, contact tradeboss, helpdesk online trading, trading platform support'
    }
  }
}

const SupportMobileView = () => {
  const [form, setForm] = useState({
  fname: '',
  phoneno: '',
  emailid: '',
  description: '',
  filename: '',
  base64:"",
});

const [errtype, setErrType] = useState(0);
const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg]=useState("")

    const { language } = useLanguage();
    const translations = { en, hi, kn,gu,ma };
    const t = translations[language];

const handleInputChange = (key, value) => {
  setForm({ ...form, [key]: value });
  setSuccessMsg("")
};

// const handleFileChange = (file) => {
//   setForm({ ...form, filename: file.name });
// };


  const handlePicFile = async (file) => {
    if (!file) {
      setErrType(5);
      setErrorMsg("No file selected.");
      setSuccessMsg("")
      return;
    }

    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validImageTypes.includes(file.type)) {
      setErrType(5);
      setErrorMsg("Invalid file type. Please upload an image (JPEG, PNG, JPG)");
      setSuccessMsg("")
      setForm((prev) => ({ ...prev, base64: "", filename: "" }));
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5 MB
    if (file.size > maxSize) {
      setErrType(5);
      setErrorMsg("File size exceeds the 5MB limit.");
      setSuccessMsg("")
      setForm((prev) => ({ ...prev, base64: "", filename: "" }));
      return;
    }

    const fileReader = new FileReader();
    fileReader.onload = async () => {
      try {
        const base64Image = fileReader.result.split(",")[1];
        const data = `data:image/jpeg;base64,${base64Image}`;

        setForm((prev) => ({
          ...prev,
          base64: data,
          filename: file.name,
          file: file,
        }));

        setErrorMsg("");
        setSuccessMsg("")
      } catch (error) {
        console.error("Error converting image to Base64:", error);
      }
    };

    fileReader.readAsDataURL(file);
  };


console.log(form.filename)
  const Submitquery = async () => {

    if (!form.fname.trim()) {
      setErrType(1);
      setErrorMsg("Name is required");
      return;
    } else if (!/^[A-Za-z\s]+$/.test(form.fname)) {
      setErrType(1);
      setErrorMsg("Name should contain only alphabets");
      return;
    }


    if (!form.phoneno.trim()) {
      setErrType(2);
      setErrorMsg("Contact number is required");
      return;
    } else if (!/^\d{10}$/.test(form.phoneno)) {
      setErrType(2);
      setErrorMsg("Enter a valid 10-digit contact number");
      return;
    }


    if (!form.emailid.trim()) {
      setErrType(4);
      setErrorMsg("Email is required");
      return;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.emailid)) {
      setErrType(4);
      setErrorMsg("Enter a valid email address");
      return;
    }


    if (!form.description || !form.description.trim()) {
      setErrType(3);
      setErrorMsg("Description is required");
      return;
    }

    setErrType(0);
    setErrorMsg("");

    const payload = {
      data: {
        type: "Support",
        name: form.fname,
        email: form.emailid,
        mobile: form.phoneno,
        description: form.description,
        base64: form.base64 || ""
      },
    };

    console.log("Form submitted successfully", payload);

    try {
      const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.ticket}`, payload)

      if (response.data?.data?.status == 200) {
        setForm({
          fname: "",
          emailid: "",
          phoneno: "",
          description: "",
          base64: ""
        })
        setSuccessMsg("Your query has been submitted successfully!")
      }

    } catch (error) {
      setSuccessMsg("")
      console.log(error)
    }

    // Add actual submission logic here
  };


 // Allowed file types

  return (
    <Grid container className="outerCard" spacing={2} sx={{ padding: 2, borderRadius: 2}} >
      <DocumentMeta {...meta} />
      {/* Query Section */}
      <Grid item xs={12} md={6} sx={{ mt: 10, mb: 6 }}>

        <div className="headingContainer">
                    <div className="gradientBackground"></div>
                    <Typography className="heading1" style={{ fontWeight: 600 }}>
                      {t.heading}
                      {/* Contact Us */}
                    </Typography>
        </div>


        <h1 className="m_sup_txt">
          {t.tradeboss}
        </h1>

        {/* Name Input */}
        <Typography className="m_hva_qry">
          {t.have_query}
        </Typography>

        {/* <FormControl fullWidth variant="standard" sx={{ mb: 4 }}>
  <TextField
    size="small"
    variant="standard"
    label="Name"
    fullWidth
    value={form.fname}
    onChange={(e) => handleInputChange('fname', e.target.value)}
    sx={{
      '& .MuiInput-underline:before': { borderBottomColor: '#999' },
      '& .MuiInput-underline:after': { borderBottomColor: '#999' },
    }}
    InputLabelProps={{
      sx: {
        color: errtype === 1 ? '#F74542' : '#999 !important',
        fontFamily: 'Inter400',
        fontSize: '18px',
      },
    }}
    InputProps={{
      sx: {
        color: typeof window !== 'undefined' && window.innerWidth < 960 ? '#ffffff' : '#0B1420',
        fontFamily: 'cardiuma-regular',
        fontSize: '18px',
        height: '30px',
      },
    }}
  />
  {errtype === 1 && (
    <FormHelperText sx={{ color: '#F74542', fontFamily: 'cardiuma-regular' }}>
      {errorMsg}
    </FormHelperText>
  )}
</FormControl> */}


<Grid sx={{marginBottom:"20px"}}>
          <Paper component="form" className="field">

            <InputBase
              className="inputbase"
              name="name"
              type="name"
              placeholder={t.form.placeholder.name}
              onChange={(e) => handleInputChange('fname', e.target.value)}
              autoComplete="name"
              inputProps={{
                "aria-label": "Name"
              }}
              value={form.fname}
            />

          </Paper>
          {
            errtype == 1 && <p className="errMsgg">{errorMsg}</p>
          }

          <Paper component="form" className="field">

            <InputBase
              className="inputbase"
              name="tel"
              placeholder={t.form.placeholder.contact_no}
              onChange={(e) => handleInputChange('phoneno', e.target.value)}
              autoComplete="tel"
              inputProps={{
                "aria-label": "Phone Number",
                inputMode: "numeric",
              }}
              value={form.phoneno}
            />

          </Paper>
          {
            errtype == 2 && <p className="errMsgg">{errorMsg}</p>
          }

          <Paper component="form" className="field">

            <InputBase
              className="inputbase"
              name="emailid"
              type="email"
              placeholder={t.form.placeholder.email_id}
              onChange={(e) => handleInputChange('emailid', e.target.value)}
              autoComplete="email"
              inputProps={{
                "aria-label": "email"
              }}
              value={form.emailid}
            />

          </Paper>
          {
            errtype == 4 && <p className="errMsgg">{errorMsg}</p>
          }

          <Paper component="form" className="field">

            <InputBase
              className="inputbase"
              name="description"
              type="description"
              placeholder={t.form.placeholder.query_description}
              autoComplete="description"
              inputProps={{
                "aria-label": "Description"
              }}
              onChange={(e) => handleInputChange('description', e.target.value)}
              value={form.description}
            />

          </Paper>
          {
            errtype == 3 && <p className="errMsgg">{errorMsg}</p>
          }
</Grid>


        {/* Contact Number Input */}
        {/* <FormControl fullWidth variant="standard" sx={{ mb: 4 }}>
  <TextField
    size="small"
    variant="standard"
    label="Contact number"
    fullWidth
    value={form.phoneno}
    onChange={(e) => handleInputChange('phoneno', e.target.value)}
    sx={{
      '& .MuiInput-underline:before': { borderBottomColor: '#999' },
      '& .MuiInput-underline:after': { borderBottomColor: '#999' },
    }}
    InputLabelProps={{
      sx: {
        color: errtype === 2 ? '#F74542' : '#999 !important',
        fontFamily: 'Inter400',
        fontSize: '18px',
      }
    }}
    InputProps={{
      sx: {
        color: typeof window !== 'undefined' && window.innerWidth < 960 ? '#ffffff' : '#0B1420',
        fontFamily: 'cardiuma-regular',
        fontSize: '18px',
        height: '30px',
      },
    }}
  />
  {errtype === 2 && (
    <FormHelperText sx={{ color: '#F74542', fontFamily: 'cardiuma-regular' }}>
      {errorMsg}
    </FormHelperText>
  )}
</FormControl> */}


        {/* Email Input */}
       {/* <FormControl fullWidth variant="standard" sx={{ mb: 4 }}>
  <TextField
    size="small"
    variant="standard"
    label="Email ID"
    fullWidth
    value={form.emailid}
    onChange={(e) => handleInputChange('emailid', e.target.value)}
    sx={{
      '& .MuiInput-underline:before': { borderBottomColor: '#999' },
      '& .MuiInput-underline:after': { borderBottomColor: '#999' },
    }}
    InputLabelProps={{
      sx: {
        color: errtype === 4 ? '#F74542' : '#999 !important',
        fontFamily: 'Inter400',
        fontSize: '18px',
      },
    }}
    InputProps={{
      sx: {
        color: typeof window !== 'undefined' && window.innerWidth < 960 ? '#ffffff' : '#0B1420',
        fontFamily: 'cardiuma-regular',
        fontSize: '18px',
        height: '30px',
      },
    }}
  />
  {errtype === 4 && (
    <FormHelperText sx={{ color: '#F74542', fontFamily: 'cardiuma-regular' }}>
      {errorMsg}
    </FormHelperText>
  )}
</FormControl> */}





        {/* File Upload Section */}
        <FileUploader
          multiple={false}
          maxSize="1mb"
          handleChange={(file) => {
            handlePicFile(file);
          }}
          name="file"
        >
          <Box sx={{ padding: '20px', borderRadius: '8px', border: '2px dashed #999', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography sx={{ color: '#666666', fontFamily: "Inter400", fontSize: 'calc(14px + var(--font-delta))' }}>{t.drag_drop}</Typography>
            <Typography style={{ color: '#FFE585', fontFamily: "Inter700", cursor: 'pointer', fontSize: 'calc(14px + var(--font-delta))' }}>{t.browse_file} </Typography>
          </Box>
        </FileUploader>


        {/* Filename & Secure Info */}
        <Grid container sx={{ mt: 1 }}>
          <Grid item xs={9}>
            {/* <Typography sx={{ color: '#7A7C7F', fontSize: '14px' }}>{form.filename}</Typography> */}
          </Grid>
          <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <img src={Secure} alt="Secure" style={{ marginRight: '8px' }} />
            <Typography sx={{ color: '#7A7C7F', fontFamily: "Inter400", fontSize: 'calc(14px + var(--font-delta))' }}>Secure</Typography>
          </Grid>
        </Grid>


          {errtype === 5 && (
            <p className="errMsgg">{errorMsg}</p>
          )}

          {form.filename && (
            <Typography
              className="successMsg"
            >
              {form.filename}
            </Typography>
          )}

          {successMsg && (
            <Typography
              className="successMsg"
            >
              {successMsg}
            </Typography>
          )}





        {/* Submit Button */}
        <Button fullWidth sx={{ mt: 3 }} onClick={Submitquery} className="m_crt_tkt">
          {t.create_ticket}
        </Button>
      </Grid>

      {/* Contact Details Section */}
      <Grid item xs={12} md={6} sx={{ mt: 0, mb: 2 }}>
        {/* Logo */}
  <Box sx={{ mb: 2, textAlign: { xs: 'center', md: 'left' } }}>
    <img
      src={TradeBossLogo}
      alt="Trade Boss Logo"
      style={{ width: '150px', maxWidth: '50%', height: 'auto' }}
    />
  </Box>

        <Grid container spacing={2} >
  {/* Address Card */}
  <Grid item xs={12} sm={6}>
            <Box sx={{ padding: "12px 12px 0px 12px", borderRadius: 2 }}>
      <Typography className="m_triv_txt">
                {t.title}
      </Typography>
      <Typography className="m_triv_txt">

                <span className="span" style={{ fontWeight: 600 }}>{t.regOff}</span>{t.regAdd}
                 {t.regAdd1}
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', padding: "12px 12px 0px 12px", borderRadius: 2 }}>
                      <a href="tel: +91 74003 62816" aria-label="Call">
                        <img src={call} alt="icon"  className="icons" />
                      </a>
                      <Typography className="m_sup_cnt_txt">+91 74003 62816</Typography>
                    </Box>

                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', padding: "12px 12px 12px 12px", borderRadius: 2 }}>
                      <a href="mailto:info@tradeboss.co" aria-label="Email customer care">
                        <img src={msg} alt="icon" className="icons" />
                      </a>
                      <Typography className="m_sup_cnt_txt">  info@tradeboss.co</Typography>
                    </Box>
                  </Grid>
                </Grid>

                <span className="span" style={{ fontWeight: "600" }}>{t.copOff}</span>{t.copAdd} {t.copAdd1}<br />
                <Grid container spacing={1} >
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', padding: "12px 12px 0px 12px", borderRadius: 2 }}>
                      <a href="tel:  +91 77384 60922" aria-label="Call">
                        <img src={call} alt="icon" className="icons" />
                      </a>
                      <Typography className="m_sup_cnt_txt">  +91 77384 60922</Typography>
                    </Box>

                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', padding: "12px 12px 0px 12px", borderRadius: 2 }}>
                      <a href="mailto:  info@tradeboss.co" aria-label="Email customer care">
                        <img src={msg} alt="icon" className="icons" />
                      </a>
                      <Typography className="m_sup_cnt_txt">info@tradeboss.co</Typography>
                    </Box>
                  </Grid>
                </Grid>
      </Typography>
    </Box>
  </Grid>

  {/* Registration Info */}
  <Grid item xs={12} sm={6}>
      <Box sx={{ padding: "0px 12px 0px 12px" }}>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.NSE}</Typography>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.BSE}</Typography>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.SEBI}</Typography>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.CDSL}</Typography>
    </Box>
  </Grid>

  {/* Company Info */}
  <Grid item xs={12} sm={6}>
            <Box sx={{ padding: "12px 12px 12px 12px"  }}>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.CIN}</Typography>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.PAN}</Typography>
              <Typography className="m_triv_txt1" style={{ fontWeight: 600 }}>{t.GSTIN}</Typography>

    </Box>
  </Grid>
</Grid>


        {/* Phone and Email Contacts */}

      </Grid>
    </Grid>
  );
};

export default SupportMobileView;
